import React from "react";
import styleClasses from './css/MyPage.module.scss';

const MusicardCTA = ({ music, setMusic, artistType, setArtistType }) => {
  return (
    <>
      <div className={styleClasses.myPage}>
        <div className={styleClasses.inner}>
          <div className={ styleClasses.cta }>
            <div className={ styleClasses.inner }>
              <div className="commonForm">
                {/* 음원 발매 경력 라디오 버튼 */}
                <div className="formRow fullWidth">
                  <div className="labelBox">
                    <label>음원 발매 여부 선택</label>
                  </div>
                  <div className="fieldBox checkBox">
                    <div className="eachBox">
                      <input
                        type="radio"
                        name="music"
                        id="released"
                        value="released"
                        checked={music === "released"}
                        onChange={(e) => setMusic(e.target.value)}
                      />
                      <label htmlFor="released">
                        발매 이력 있음
                        <div className="commonIcon toolTip">
                          <i className="questionBlack w16"></i>
                          <div className="toolTipText bottom">
                            <p>유튜브 뮤직에서 검색이 가능한 경우 선택해 주세요.</p>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="fieldBox checkBox">
                    <div className="eachBox">
                      <input
                        type="radio"
                        name="music"
                        id="unreleased"
                        value="unreleased"
                        checked={music === "unreleased"}
                        onChange={(e) => setMusic(e.target.value)}
                        />
                      <label htmlFor="unreleased">
                        발매 이력 없음
                        <div className="commonIcon toolTip">
                          <i className="questionBlack w16"></i>
                          <div className="toolTipText bottom">
                            <p>정식 유통은 하지 않았지만, <br />사운드 클라우드에 음원이 업로드 되어 있는 경우 선택해주세요.</p>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                {/* 팀/솔로 라디오 버튼 */}
                <div className="formRow fullWidth">
                  <div className="labelBox">
                    <label>활동 형태</label>
                  </div>
                  <div className="fieldBox checkBox">
                    <div className="eachBox">
                      <input
                        type="radio"
                        name="artistType"
                        id="solo"
                        value="solo"
                        checked={artistType === "solo"}
                        onChange={(e) => setArtistType(e.target.value)}
                        />
                      <label htmlFor="solo">솔로</label>
                    </div>
                  </div>
                  <div className="fieldBox checkBox">
                    <div className="eachBox">
                      <input
                        type="radio"
                        name="artistType"
                        id="team"
                        value="team"
                        checked={artistType === "team"}
                        onChange={(e) => setArtistType(e.target.value)}
                      />
                      <label htmlFor="team">팀 혹은 밴드</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MusicardCTA;